import { Grid, GridColumn, GridRow, TableRow } from 'semantic-ui-react';
import React from 'react';
import DateFormat from './DateFormat';
import { FormattedMessage, useIntl } from 'react-intl';
import MailTo from './MailTo';

const inFormat = 'hh:mm:ss A UTC DD-MMM-YYYY';

const WORKFLOW_STEP_STATUSES = {
  completed: 'completed',
};

const SignatureExecutionStatus = (props) => {
  const step = props.step;
  const status = step.workflowStepStatus;
  const workflowStepType = step.workflowStepType;
  const allow_zensign = step.allow_zensign;
  const completed_at = step.completed_at;
  const rejected_at = step.rejected_at;
  const updated_at = step.updated_at;
  const external_step_status = step.external_step_status;

  const statusMap = {
    active: {
      label: 'signature.alert_sent',
      EMAIL_SENT: { label: 'signature.zensign_email_sent', date: updated_at },
      ITEM_VIEWED: { label: 'signature.zensign_item_viewed', date: updated_at },
    },
    waiting: {
      label: 'signature.waiting_prior_steps',
      WAITING_FOR_PREVIOUS: { label: 'signature.zensign_waiting_prior_steps' },
    },
    completed: {
      label: workflowStepType === 'signature' ? 'signature.completed' : 'signature.viewed',
      date: completed_at,
      COMPLETED: { label: 'signature.zensign_completed', date: completed_at },
    },
    rejected: {
      label: 'signature.rejected',
      date: rejected_at,
      REJECTED: { label: 'signature.zensign_rejected', date: rejected_at },
    },
  };
  const { label, date } = allow_zensign ? statusMap[status][external_step_status] : statusMap[status];
  return (
    <span className="signature-execution-status">
      <FormattedMessage id={label} defaultMessage={label} />
      {date ? <DateFormat date={date} inFormat={inFormat}></DateFormat> : ''}
    </span>
  );
};

export default function SignatureRow(props) {
  const signatureDetails = props.signature;
  const stepName = signatureDetails?.stepName;
  const signatureReason = signatureDetails?.signatureReason;
  const email = signatureDetails?.email;
  const userTitleAtTheTime = signatureDetails?.role;
  const comment = signatureDetails?.comment;

  const intl = useIntl();

  const getUserName = (signature) => {
    const isCompleted = signature?.workflowStepStatus === WORKFLOW_STEP_STATUSES.completed;
    const isActiveOrExternal = signature?.userIsActive || signature?.isExternalAssignment;

    if (isCompleted) {
      return signature?.assigneeName;
    } else if (isActiveOrExternal) {
      return signature?.assigneeName;
    } else {
      return `${signature?.assigneeName} *${intl
        .formatMessage({ id: 'common.disabled', defaultMessage: 'disabled' })
        .toUpperCase()}*`;
    }
  };

  return (
    <TableRow className="signature-body-wrapper">
      <Grid stackable>
        <GridRow width="16">
          <GridColumn width={8}>
            <div className="bold name">{getUserName(signatureDetails)}</div>
            <div className="title"> {userTitleAtTheTime}</div>
            <div className="email">
              <MailTo email={email} />
            </div>
          </GridColumn>
          <GridColumn width={8}>
            <div className="bold step-name">{stepName}</div>
            <div className="signature-reason"> {signatureReason}</div>
            <SignatureExecutionStatus step={signatureDetails}></SignatureExecutionStatus>
          </GridColumn>
        </GridRow>
        {comment && (
          <li className="italic-red comment">
            <FormattedMessage id="common.comment" defaultMessage={`Comment: ${comment}`} values={{ comment }} />
          </li>
        )}
      </Grid>
    </TableRow>
  );
}
